import * as React from "react";
import { useQuery } from "@apollo/client";
import {
  GET_PANUI,
  Page,
  PanuiGridTypeData,
  PanuiQueryData,
  showLoad,
} from "@plinknz/tah-website-elements";

import { Hero } from "../hero";
import { Loader } from "../loader";
import { NewsGridBlock } from "./news-grid-block";
import { NotFound } from "../../views/404";

export interface PanuiGridProps {
  data: PanuiGridTypeData;
}

export const PanuiGridBlock = ({ data }: PanuiGridProps) => {
  const { items_to_show: itemsToShow, pages } = data;
  const pagesExist = !!pages.length;

  // If there are pages, then show them (and make the query a noop),
  // otherwise query items_to_show worth

  let limit = itemsToShow;
  let slug: {
    eq?: string;
    ne?: string;
  } = { ne: "__zz__" };

  if (pagesExist) {
    limit = 0;
    slug = { eq: "__zz__" };
  }

  const { loading, data: queryData, error } = useQuery<PanuiQueryData>(
    GET_PANUI,
    {
      variables: {
        filters: { slug },
        pagination: { limit },
      },
    }
  );

  const formatSlugs = (page: Page): Page => ({
    ...page,
    slug: `/panui/${page.slug}`,
  });

  if (pagesExist) {
    const newData = {
      ...data,
      pages: data.pages.map(formatSlugs),
    };

    // eslint-disable-next-line react/no-children-prop
    return <NewsGridBlock data={newData} children={[]} />;
  }

  if (!queryData && showLoad(loading)) {
    return (
      <div className="splash">
        <Loader size="large" />
      </div>
    );
  }

  if (error) {
    console.warn(error);
    const errorMessage = error?.graphQLErrors
      .map((graphqlError) =>
        graphqlError.extensions?.exception
          ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-member-access
            `${graphqlError.extensions.exception.output.statusCode} ${graphqlError.extensions.exception.message}`
          : null
      )
      .filter(Boolean)
      .join(", ");

    return (
      <Hero title="There was an unexpected error" subtitle={errorMessage} />
    );
  }

  if (!queryData?.newsItems || queryData?.newsItems.length === 0) {
    return <NotFound />;
  }

  const newData = {
    ...data,
    pages: queryData.newsItems
      .map((item) => ({
        ...item,
        title: item.headline,
      }))
      .map(formatSlugs),
  };

  // eslint-disable-next-line react/no-children-prop
  return <NewsGridBlock data={newData} children={[]} />;
};
